<mat-checkbox #myCheckbox color="accent" [disabled]="myCheckbox.checked" [checked]="commands[0].isDisabled(el)"
    (change)="onChange($event)"></mat-checkbox>